var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.13 12.51l1.77-1.78L10 .84l-9.9 9.9 1.77 1.77L10 4.38l8.13 8.13z",
    fill: "currentColor"
  })));
}
export default SvgChevronUp;